import { useEffect, useState } from "react";
import { upsertTag, uuidMapping } from "../helper";

const EMPTY_RATING = {
  start_value: 0,
  end_value: 0,
  include_unrated: false,
};

export const useRatingFilter = (talentFilter, talentFilterTags) => {
  const [rating, setRating] = useState(
    talentFilter?.company_rating || {
      start_value: 0,
      end_value: 0,
      include_unrated: false,
    }
  );

  const [isUnrated, setIsUnrated] = useState(
    talentFilter?.company_rating?.include_unrated || false
  );

  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    if (talentFilter?.company_rating) {
      setRating(talentFilter.company_rating);
      setIsUnrated(!!talentFilter.company_rating.include_unrated);
    } else {
      clearRating();
    }
  }, [talentFilter]);

  useEffect(() => {
    if (isUnrated) {
      setIsDisabled(false);
    } else if (!rating.start_value || !rating.end_value) {
      setIsDisabled(true);
    } else {
      setIsDisabled(rating.end_value < rating.start_value);
    }
  }, [rating, isUnrated]);

  const clearRating = () => {
    setRating(EMPTY_RATING);
    setIsUnrated(false);
    setIsDisabled(true);
  };

  const buildRatingFilter = () => {
    if (isDisabled) return null;

    const finalRating = {
      ...rating,
      include_unrated: isUnrated,
    };

    const tags = upsertTag(
      talentFilterTags,
      uuidMapping.rating,
      finalRating
    );

    return { company_rating: finalRating, tags };
  };

  return {
    rating,
    isUnrated,
    isDisabled,
    setMin: (v) => setRating(r => ({ ...r, start_value: v })),
    setMax: (v) => setRating(r => ({ ...r, end_value: v })),
    setIsUnrated,
    buildRatingFilter,
    clearRating
  };
};
